import React, { createContext, useState, useContext } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [userName, setUserName] = useState(
    localStorage.getItem("userName") || "User"
  );
  const [profileImg, setProfileImg] = useState(
    localStorage.getItem("profileImg") || null
  );

  // You can add functions to update localStorage here as well

  return (
    <AuthContext.Provider
      value={{ userName, setUserName, profileImg, setProfileImg }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
